import { createRequestActions } from "common/helpers/action";

export const initTransactionAdd = createRequestActions("KKM.TRANSACTION.INIT");
export const sendFormTransactionAdd = createRequestActions("KKM.TRANSACTION.SEND_FORM");
